/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionInformationsQuery = gql`
  query GetSouscriptionInformationsQuery {
    getSouscriptionInformations_souscription_informations {
      customer {
 emails {
 value  
type  
} 
phones {
 internationalCode  
number  
isMobile  
} 
addresses {
 fields  
city  
zipCode  
country  
} 
GDPR {
 email  
phone  
company  
partners  
} 
}
      cfeContributionsPaidByRepresentative 
      representative {
 lastName  
addresses {
 fields  
city  
zipCode  
country  
} 
phones {
 internationalCode  
number  
isMobile  
} 
}
    }
  }
`;

export default GetSouscriptionInformationsQuery;
